module.exports = __webpack_public_path__ + "static/media/orange-roughy.55708e7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/orange-roughy.png
// module id = 325
// module chunks = 0